import z from 'zod'
import { GeometrySchema } from '../../../@shared/infra/schemas/Geometry.schema'

export const CreateExclusionZoneSchema = z
	.object({
		name: z.string(),
		description: z.string(),
		monitoredAreaId: z.uuid(),
		zones: z.array(GeometrySchema),
	})
	.transform((data) => {
		return {
			id_area_monitorada: data.monitoredAreaId,
			nome: data.name,
			descricao: data.description,
			geometrias: data.zones.map((zone) => JSON.stringify(zone)),
		}
	})
